import styled from 'styled-components'
import theme from '../../../../../../themes/light'

const CustomField = styled.span`
  color: ${theme.colors.blue};
  background-color: ${theme.colors.gray20};
`

export default CustomField
